<template>
  <v-container fluid class="customer-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            Customer
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-profiles`"
          >
          <v-icon class="mr-3">mdi-account-box</v-icon>
            Profile
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="9" sm="9">
                  <p class="text-h5">Edit Customer</p>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'customername')"
                        v-bind:value="initvalue.customername"
                        placeholder="Customer Name"
                        persistent-hint
                        single-line hint="Enter the customer name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'customercontact')"
                        v-bind:value="initvalue.customercontact"
                        placeholder="Contact Person"
                        persistent-hint
                        single-line hint="Enter the contact person">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'customerphone')"
                        v-bind:value="initvalue.customerphone"
                        placeholder="Customer Phone"
                        persistent-hint
                        single-line hint="Enter the customer phone">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'customermobile')"
                        v-bind:value="initvalue.customermobile"
                        placeholder="Customer Mobile"
                        persistent-hint
                        single-line hint="Enter the customer mobile">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <v-textarea
                        v-on:change="updateChangedValue($event, 'customeraddress')"
                        v-bind:value="initvalue.customeraddress"
                        outlined
                        rows=3
                        label="Address"
                        hint="please enter the customer address"
                      ></v-textarea>
                      <v-select
                        class="mb-4"
                        :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                        :value="initvalue.regionid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regionid')"
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="townships.map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                        :value="initvalue.townshipid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'townshipid')"
                        placeholder="Township"
                        persistent-hint
                        single-line hint="Please choose the township">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="users.map(x => {
                            return {text: x.username, value: x._id};
                          })"
                        :value="initvalue.userid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'userid')"
                        placeholder="Sales Rep"
                        persistent-hint
                        single-line hint="Please choose the sales rep">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['Customer', 'Other Customer']"
                        :value="initvalue.customertype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'customertype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the customer type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                          })"
                        :value="initvalue.pricelistid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'pricelistid')"
                        placeholder="Price List"
                        persistent-hint
                        single-line hint="Please choose the pricelist">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'customerstatus')"
                          v-bind:label="initvalue.customerstatus"
                          v-model="initvalue.customerstatus"
                          value="Active"
                          true-value="Active"
                          false-value="Inactive"
                      ></v-switch>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'isTaxExempt')"
                          label="Customer Tax Exempt"
                          v-model="initvalue.isTaxExempt"
                          :true-value="true"
                          :false-value="false"
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9" sm="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/customer/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCustomer()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/customer/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-profiles'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Profiles</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showProfileDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="profileHeaders"
                        :items="customerprofiles"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteProfileDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this Profile? </v-card-title>
                              <v-card-text>
                                {{ deleteprofile.profilename }} - {{ deleteprofile.variationid!=null ? getVariationOptions(deleteprofile.variationid) : ''  }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteProfileDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourProfile(deleteprofile)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.options="{ item }">
                          <p v-for="profile in getProfileOptions(item.options)" v-bind:key="profile" class="two-line">{{ profile }}</p>
                        </template>
                        <template v-slot:item.variationid="{ item }">
                          <p class="two-line">{{ item.profilename }}</p>
                          <p class="two-line">{{ getVariationOptions(item.variationid) }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editTourProfileSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTourProfileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/tour/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      scrollable
      v-model="showProfileDialog"
      persistent
      width="1000px"
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Profile</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
            <v-col cols="6">
              <v-combobox
                v-model="profile.groups"
                  :items="itemgroups.map(x => {
                            return {text: x.itemgroupname, value: x._id};
                          })"
                label="Select item groups sold by customer"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model="profile.categories"
                  :items="itemcategories.map(x => {
                            return {text: x.itemcategoryname, value: x._id};
                          })"
                label="Select item categories sold by customer"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model="profile.ownBrands"
                  :items="brands.filter(x=>x.brandtype=='Brand').map(x => {
                            return {text: x.brandcode, value: x._id};
                          })"
                label="Select Own brands sold by customer"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model="profile.otherBrands"
                  :items="brands.filter(x=>x.brandtype=='Other Brand').map(x => {
                            return {text: x.brandcode, value: x._id};
                          })"
                label="Select Other brands sold by customer"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="profile.ownItems"
                  :items="items.map(x => {
                            return {text: x.itemname, value: x._id};
                          })"
                label="Select Own items sold by customer"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model="profile.haveOwnPosm"
                  :items="posmtypes"
                label="Select Own POSM in customer's outlet"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model="profile.haveOtherPosm"
                  :items="posmtypes"
                label="Select Other POSM in customer's outlet"
                multiple
                chips
              ></v-combobox>
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="profile.requestedPosm"
                  :items="posmtypes"
                label="Select POSM requested by customer"
                multiple
                chips
              ></v-combobox>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="profile.profilenote"
                  label="Note"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showProfileDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addCustomerProfile"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      customer: {},
      photo: {},
      initvalue: {},
      imageurl: undefined,
      profile: {},
      customerprofiles: [],
      profileHeaders: [
        { text: "Brands", value: "ownBrands" },
        { text: "Items", value: "ownItems" },
        { text: "Posm", value: "haveOwnPosm" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      posmtypes: ["Catalog", "Display Stand", "Fridge", "Poster", "Signage", "Sunshade", "Vinyl", "Umbrella"],
      deleteprofile: {},
      editprofile: {},
      deleteProfileDialog: false,
      showProfileSheet: false,
      showProfileDialog: false,
    }
  },
  methods: {
    ...mapActions('Customer', [
      'getCustomersRequest',
      'insertCustomerProfileRequest',
      'updateCustomerRequest','updateCustomerImageRequest','updateCustomerPinRequest',
    ]),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('ItemCategory', ['getItemCategoriesRequest']),
    ...mapActions('ItemGroup', ['getItemGroupsRequest']),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['getTownshipsRequest']),
    ...mapActions('User', ['getUsersRequest']),
    prepareProfile(){
      let payload = this.profile;
      payload.ownItems = payload.ownItems.map(x=>x.value);
      payload.ownBrands = payload.ownBrands.map(x=>x.value);
      payload.otherBrands = payload.otherBrands.map(x=>x.value);
      payload.categories = payload.categories.map(x=>x.value);
      payload.groups = payload.groups.map(x=>x.value);
    },
    async addCustomerProfile() {
      this.showProfileDialog = false;
      this.prepareProfile();
      let payload = this.profile;
      payload.customerid = this.initvalue._id;
      console.log(this.payload);
      let result = await this.insertCustomerProfileRequest(payload);
      this.customerprofiles.push(result);
      this.profile = {};
    },
    async editCustomer() {
      this.customer._id = this.initvalue._id;
      await this.updateCustomerRequest(this.customer);
      router.push('/customer/list');
    },
    editDetail() {
      this.detail._id = this.initvalue._id;
      this.updateCustomerRequest(this.detail);
      this.getCustomersRequest();
      router.push('/customer/list');
    },
    editPhoto() {
      console.log(this.photo)
      this.photo._id = this.initvalue._id;
      this.updateCustomerImageRequest(this.photo);
      this.getCustomersRequest();
      router.push('/customer/list');
    },
    editPin() {
      console.log(this.pin);
      if(this.pin.customerpin == undefined || this.pin.customerpin.length<6){
        this.pin.error = true;
        return;
      }
      this.pin.error = false;
      if(this.pin.customerpin !== this.pin.customerpin2){
        this.pin.error2 = true;
        return;
      }
      this.pin.error2 = false;
      this.pin._id = this.initvalue._id;
      console.log(this.pin);
      this.updateCustomerRequest(this.pin);
      this.getCustomersRequest();
      router.push('/customer/list');
    },
    updateChangedValue(value, field){
      console.log(value, field);
      this.customer[field] = value;
    },
    updateChangedDetail(value, field){
      console.log(value, field);
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.customerimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Customer', ['isReceiving']),
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
    ...mapState('List', ['lists']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  async created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.customerimage;
    this.customerprofiles = this.initvalue.customerprofiles;
    if(!this.initvalue._id) this.$router.push({ name: 'CustomerList' });
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) await this.getItemGroupsRequest();
    if(this.pricelists.length==0) await this.getPriceListsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
